import { render, staticRenderFns } from "./updates-widget.vue?vue&type=template&id=774d3198&"
import script from "./updates-widget.vue?vue&type=script&lang=js&"
export * from "./updates-widget.vue?vue&type=script&lang=js&"
import style0 from "./updates-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports